<!------------------------------Main Content------------------------------>
<section id="statsTable">
  <!--------------------Table-------------------->
  <!----------Table Header---------->
  <app-table-header
    [tableHeader]="statsTableHeader"
    [orderByColumnDefault]="statsTableHeader[1]"
    [isCheckboxColumnVisible]="false"
    [isStickyEnabled]="false"
  >
  </app-table-header>
  <!----------Table Content---------->
  <div class="table-content">
    <ng-container *ngIf="statsProcessed && loadTable" ;else nodata>
      <div>
        <div class="office-item-container">
          <div id="blank"></div>
          <div class="table-item" id="id">
            <p class="subheading-02-medium">{{ statsProcessed.lite }}</p>
          </div>
          <div class="table-item" id="id">
            <p class="subheading-02-medium">{{ statsProcessed.basic }}</p>
          </div>
          <div class="table-item" id="id">
            <p class="subheading-02-medium">{{ statsProcessed.jupiter }}</p>
          </div>
          <div class="table-item" id="id">
            <p class="subheading-02-medium">
              {{ statsProcessed.sumBonificada }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!----------Table Empty Content---------->
  <ng-template #nodata>
    <p>No hay datos</p>
  </ng-template>
</section>
